import {
  GET_FUNDING_SOURCE,
  GET_FUNDING_SOURCE_SUCCESS,
  GET_FUNDING_SOURCE_ERROR,
  APPLICATION_FUNDING_SOURCE,
  APPLICATION_FUNDING_SOURCE_SUCCESS,
  APPLICATION_FUNDING_SOURCE_ERROR,
  UPDATE_APPLICATION_FUNDING_SOURCE,
  UPDATE_APPLICATION_FUNDING_SOURCE_SUCCESS,
  UPDATE_APPLICATION_FUNDING_SOURCE_ERROR,
  GET_FUNDING_SOURCE_ACCOUNT_DETAILS_SUCCESS,
  GET_FUNDING_SOURCE_ACCOUNT_DETAILS,
  GET_FUNDING_ACCOUNT_PURPOSE,
  GET_FUNDING_ACCOUNT_PURPOSE_SUCCESS,
  GET_FUNDING_ACCOUNT_PURPOSE_ERROR,
} from './FundingSourceConstants';

export const getFundingSource = (payload) => ({
  type: GET_FUNDING_SOURCE,
  payload,
});

export const getFundingSourceSuccess = (payload) => ({
  type: GET_FUNDING_SOURCE_SUCCESS,
  payload,
});

export const setFundingSourceDetails = (payload) => ({
  type: GET_FUNDING_SOURCE_ACCOUNT_DETAILS_SUCCESS,
  payload,
});

export const getFundingSourceDetails = (payload) => ({
  type: GET_FUNDING_SOURCE_ACCOUNT_DETAILS,
  payload,
});

export const getFundingSourceError = (payload) => ({
  type: GET_FUNDING_SOURCE_ERROR,
  payload,
});

export const applicationFundingSource = (payload) => ({
  type: APPLICATION_FUNDING_SOURCE,
  payload,
});

export const applicationFundingSourceSuccess = (payload) => ({
  type: APPLICATION_FUNDING_SOURCE_SUCCESS,
  payload,
});

export const applicationFundingSourceError = (payload) => ({
  type: APPLICATION_FUNDING_SOURCE_ERROR,
  payload,
});

export const updateApplicationFundingSource = (payload) => ({
  type: UPDATE_APPLICATION_FUNDING_SOURCE,
  payload,
});

export const updateApplicationFundingSourceSuccess = (payload) => ({
  type: UPDATE_APPLICATION_FUNDING_SOURCE_SUCCESS,
  payload,
});

export const updateApplicationFundingSourceError = (payload) => ({
  type: UPDATE_APPLICATION_FUNDING_SOURCE_ERROR,
  payload,
});

export const getFundingPurpose = (payload) => ({
  type: GET_FUNDING_ACCOUNT_PURPOSE,
  payload,
});

export const getFundingPurposeSuccess = (payload) => ({
  type: GET_FUNDING_ACCOUNT_PURPOSE_SUCCESS,
  payload,
});

export const getFundingPurposeError = (payload) => ({
  type: GET_FUNDING_ACCOUNT_PURPOSE_ERROR,
  payload,
});
